export default "__VITE_ASSET__385e4583__"